import { ArcheLayout } from '../../components/ArcheLayout';
import { LearnAnythingContent } from './LearnAnythingContent';

export function LearnAnythingPage() {
  return (
    <ArcheLayout>
      <LearnAnythingContent />
    </ArcheLayout>
  );
}

export default LearnAnythingPage;
